import { render, staticRenderFns } from "./ViewAccountBank.vue?vue&type=template&id=950643c6&scoped=true"
import script from "./ViewAccountBank.vue?vue&type=script&lang=js"
export * from "./ViewAccountBank.vue?vue&type=script&lang=js"
import style0 from "./ViewAccountBank.vue?vue&type=style&index=0&id=950643c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950643c6",
  null
  
)

export default component.exports